import { AmountType } from "./AmountType";
import { ProductCatalogItem } from "./CatalogItem";

export interface Field {
    id: ID;
    label: string;
    organizerOnly: boolean;
    required: boolean;
    roster: boolean;
    addToSavedViews: boolean;
    seq?: number;
    type: FieldType;
    unit?: string;
    options?: string[];
    url?: string;
    description?: string;
    verifyAge?: boolean;
    comparator?: "older" | "younger";
    age?: number;
    value?: string;
    readonly: boolean;
    summation?: boolean;
    visibility?: FieldVisibility;
    optInByDefault?: boolean;
    displayStep?: DisplayStepOption;
    catalogItem?: ProductCatalogItem;
}

export enum QuestionnairePricingStructure {
    PER_PERSON = "perPerson",
    PER_GROUP = "perGroup",
}

export interface PostalAddress {
    streetLines?: string[];
    region?: string;
    countryCode?: string;
}

interface Location {
    postalAddress?: PostalAddress;
    name?: string;
    formattedAddress?: string;
}

export type FieldWithPickupOptions = Omit<Field, "options"> & {
    priceType?: QuestionnairePricingStructure;
    options: {
        sequence: number;
        pickupLocation: {
            id: ID;
            name?: string;
            parent?: string;
            isDeclinePickupItem?: boolean;
            arrivalOffset?: number;
            location?: Location;
        };
        localOverrides?: {
            prices?: {
                perPerson?: {
                    price: number;
                    priceType: AmountType;
                };
                perGroup?: {
                    price: number;
                    priceType: AmountType;
                };
            };
            arrivalOffset?: number;
        };
    }[];
};

export type FieldPayload = Omit<Field, "id" | "displayStep" | "catalogItem"> & {
    id?: ID;
    displayStep?: DisplayStepOption;
    catalogItem?: { id?: ID };
};

export enum FieldType {
    TEXT = "text",
    TEXTAREA = "textarea",
    SELECT = "select",
    WEIGHT = "weight",
    HEIGHT = "height",
    PICKUP = "pickupLocation",
    DATE_OF_BIRTH = "dateOfBirth",
    MARKETING_CONSENT = "marketingConsent",
    CHECKBOX = "checkbox",
    EMAIL = "email",
    PHONE = "phone",
    ADDON = "merchandise",
    PHOTO = "photo",
}

export enum FieldVisibility {
    ADULTS = "adults",
    MINORS = "minors",
    ALL = "all",
}

export enum FieldSource {
    XOLA = "xola",
    PLUGIN = "plugin",
}

export enum DisplayStepOption {
    BEFORE_PAYMENT = "beforePayment",
    AFTER_PAYMENT = "afterPayment",
    WAIVER_SIGNING = "waiverSigning",
}
